import { gql } from "apollo-boost";

export const fragments = {
  activity: gql`
    fragment ActivityFeedActivity on Activity {
      id
      activityType
      body
      public
      createdAt
      details {
        toStatus
        holdType
        holdReason
      }
      actor {
        id
        email
        name
      }
      service {
        id
        serviceType
        job {
          id
        }
      }
    }
  `
};

const JobActivitiesQuery = gql`
  query JobActivitiesQuery($jobId: ID!) {
    activities(jobId: $jobId, order: "createdAt desc") {
      ...ActivityFeedActivity
    }
  }
  ${fragments.activity}
`;

const ServiceActivitiesQuery = gql`
  query ServiceActivitiesQuery($serviceId: ID!) {
    activities(serviceId: $serviceId, order: "createdAt desc") {
      ...ActivityFeedActivity
    }
  }
  ${fragments.activity}
`;

export { JobActivitiesQuery, ServiceActivitiesQuery };



// WEBPACK FOOTER //
// ./src/queries/Activities.js